<template>
  <div class="sm-wrap lg">
    <single-maillist :list="mailList" @sort="sortTable" @action="mailAction" @groupAction="groupAction" />

    <paginate-block v-if="mailList.length" v-model="pager.onPage" :pages="pager.pages" :page="pager.page"
      :onPage="pager.onPage" :morePages="morePages" :items="pager.items" @showMore="getMoreMail" />

    <popup-block v-if="popup.isOpen" :open="popup.isOpen" :class="'sm-list__popup'"
      :size="popup.type == 'scan' || 'junk' ? 'large' : 'default'" @close="popup.isOpen = false;">
      <template slot="popupContent">
        <upload-scans v-if="popup.type == 'scan'" :settings="uploadSettings.scan" @confirm="submitUploadedScans" />
        <div v-if="popup.type == 'picture'" class="sm-list__popup-upload">
          <h4>Upload envelope picture</h4>
          <upload-file :name="popup.type" :types="uploadSettings[popup.type].types"
            :typesText="uploadSettings[popup.type].typesText" :showPreview="'big'" @upload="uploadFile"
            @delete="deleteFile" />
          <btn-block v-if="uploadedFile" :text="'Submit'" @click="submitUploadedFile" />
        </div>
        {{ /** Schedule pickup */ }}
        <template v-if="popup.type == 'pick_up' || popup.type == 'group_pick_up' || popup.type == 'mark_as_pick_up'">
          <template v-if="hasPickupRequest">
            <div v-if="pickUpProcess == 'confirm_pickup'" class="sm-flex sm-flex-column sm-gap-16">
              <div class="sm-flex sm-flex-column sm-gap-6">
                <h4>Mail pickup request</h4>
                <p>A customer has scheduled a mail pickup for {{ pickUpDate }}</p>
              </div>
              <div class="sm-flex sm-gap-1">
                <btn-block :text="'Confirm pickup'" class="sm-flex-1" @click="pickUpProcess = 'pickup_schedule'" />
                <btn-block :text="'Reschedule pickup'" :type="'text'" class="sm-flex-1" @click="pickUpProcess = 'pickup_reschedule'" />
              </div>
            </div>
            <div v-if="pickUpProcess == 'pickup_reschedule'" class="sm-flex sm-flex-column sm-gap-16">
              <div class="sm-flex sm-flex-column sm-gap-8">
                <h4>Reschedule mail pickup request</h4>
                <p>
                  You’re about to decline the pickup scheduled for <span class="sm-font-bold">{{ pickUpDate }}</span>. 
                  The customer will be notified and prompted to choose a new date. 
                  You can include a reason to help them understand why it was declined. 
                </p>
                <!-- <div class="sm-flex sm-gap-4">
                  <datepicker-wrap 
                    :label="`From`"
                    v-model="rescheduleParams.reschedule_from_date"
                    :notBefore="new Date()"
                    :disabledWeekdays="disabledWeekdays"
                    data-vv-as="date"
                    class="sm-flex-1"
                  />
                  <datepicker-wrap 
                    :label="`To`"
                    v-model="rescheduleParams.reschedule_to_date"
                    :notBefore="rescheduleParams.reschedule_from_date || new Date()"
                    :disabledWeekdays="disabledWeekdays"
                    data-vv-as="date"
                    class="sm-flex-1"
                  />
                </div> -->
                <input-text :label="'Decline reason (optional)'" :name="'reason'" v-model="rescheduleParams.reason" :placeholder="'Enter reason'" />
              </div>
              <btn-block :text="'Decline and Notify'" class="sm-m-auto" @click="SendRescheduleRequest" />
            </div>
            {{ /** Confirmation Popup */ }}
            <!-- <div v-if="pickUpProcess == 'reschedule_confirmed'" class="sm-flex sm-flex-column sm-gap-10">
              <include-svg :name="'icon-success'" :class="'sm-m-auto'" :width="70" :height="70" />
              <h4>Request declined. Customer will be notified to pick a new date.</h4>
              <btn-block :text="'Done'" class="sm-m-auto" @click="popup.isOpen = false" />  
            </div> -->
          </template>
          <schedule-pickup v-if="pickUpProcess == 'pickup_schedule' || !hasPickupRequest" :pickUpSettings="pickUpSettings" :btnText="`Pick up`" @submit="handleSchedulePickup" />
        </template>
          <!-- <div 
          v-if="popup.type == 'pick_up'"
        >
          <confirm-block
            :text="'The Customer will be invoiced. Do you want to continue?'"
            :confirmType="'green'"
            @confirm="processAction({
              id: popup.item.id,
              action: popup.type,
              params: {}
            })"
            @cancel="popup.isOpen = false"
          />
        </div> -->

        <div v-if="['pick_up_signature', 'group_pick_up_signature'].includes(popup.type)" class="sm-list__popup-sign">
          <h4>Sign mail</h4>
          <signature-block
            :confirmText="`I confirm that I have received mail item 
            #${popup.item.mail_number || popup.item.mail_numbers.join(', #')} 
            ${popup.item.sender ? 'from ' + popup.item.sender : ''} 
            on ${$moment(new Date()).format('D MMMM, YYYY') } 
            on behalf of ${popup.item.customer_full_name}`"
            @sign="mailSignature" />
        </div>
        <form v-if="['junk', 'group_junk'].includes(popup.type)" class="sm-list__popup-form" @submit.prevent="junk">
          <h4>Select a Junk Mail Option:</h4>
          <div class="sm-list__popup-form-radio junk">
            <!-- {{ popup.item }} -->
            <radiobutton-block v-for="(item, index) in popup.item.actionOptions.trash_now.admin" :key="index"
              v-model="curTrash" :type="'sys'" :text="item.title" :description="item.descr" :name="'junk'"
              :checked="((index === 0 && !curTrash.value) || (index === 1 && curTrash.value)) ? true : false"
              @input="curTrash = item" />
          </div>

          <btn-block :type="'submit'" :text="`Confirm`" />
        </form>
        <div v-if="popup.type == 'error'" class="sm-list__popup-error">
          <h4>Mail action error</h4>
          <p>{{ backError }}</p>
          <btn-block :text="'Ok'" @click="popup.isOpen = false" />
        </div>
      </template>
    </popup-block>

    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
import SingleMailList from '@/views/admin/pages/mail/components/SingleMailList';
import Spinner from '@/components/Spinner';
import PaginateBlock from '@/components/PaginateBlock';
import Popup from '@/components/Popup';
import UploadFile from '@/components/UploadFile';
import Signature from '@/components/Signature';
import Confirm from '@/components/Confirm';
import { mapGetters, mapActions } from 'vuex';
import ShortcutsData from '@/settings/mail-shortcuts';
import { ParseErrorText } from '@/utils/errors';
import UploadScans from '@/views/admin/pages/mail/components/UploadScans';
import Radiobutton from '@/components/Radiobutton';
import MailParams from '@/settings/mail';
import SchedulePickup from '@/views/customer/pages/mail/components/PickedUpDateSelector';
import InputText from '@/components/InputText.vue';
import DatepickerWrap from '@/components/DatepickerWrap.vue';
import WeekDays from '@/settings/week-days';

export default {
  name: 'single-controller',
  components: {
    'single-maillist': SingleMailList,
    'sm-spinner': Spinner,
    'paginate-block': PaginateBlock,
    'popup-block': Popup,
    'upload-file': UploadFile,
    'upload-scans': UploadScans,
    'signature-block': Signature,
    'confirm-block': Confirm,
    'radiobutton-block': Radiobutton,
    'schedule-pickup': SchedulePickup,
    'input-text': InputText,
    'datepicker-wrap': DatepickerWrap
  },
  props: {
    account_id: {
      default: null
    }
  },
  data() {
    return {
      showSpinner: false,
      list: [],
      more: [],
      rescheduleParams: {
        reschedule_from_date: null,
        reschedule_to_date: null,
        reason: ''
      },
      pager: {
        page: 1,
        pages: 1,
        items: 1,
        onPage: 24
      },
      morePages: 0,
      popup: {
        isOpen: false,
        item: null,
        type: null //values: scan, picture, pick_up_signature, error
      },
      uploadSettings: {
        scan: {
          types: ['pdf', 'image'],
          typesText: 'JPG, JPEG, PNG, GIF, HEIC, HEIF or PDF'
        },
        picture: {
          types: ['pdf', 'image'],
          typesText: 'JPG, JPEG, PNG, GIF, HEIC, HEIF or PDF'
        }
      },
      uploadedFile: null,
      curTrash: MailParams.actions.junk.options.trash_now.admin[0],
      summary: {},
      backError: '',
      pickUpSettings: [],
      selectedPickUpTime: '',
      pickUpProcess: 'confirm_pickup', // confirm_pickup, pickup_schedule, pickup_reschedule, reschedule_confirmed
    };
  },
  created() {
    this.getMailList();
    this.loadPickUpSettings()
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      provider: 'provider',
    }),
    disabledWeekdays() {
        if (!this.pickUpSettings.length)
          return [];
  
        let enabledDays = this.pickUpSettings.filter(day => !day.enabled);
  
        if (!enabledDays.length)
          return [];
  
        return enabledDays.map(day => WeekDays.find(d => d.short == day.day).id);
    },
    mailList() {
      return [...this.list, ...this.more];
    },
    pickUpDate() {
      return this.popup.item.pick_up_scheduled_at ? this.$moment(this.popup.item.pick_up_scheduled_at).format('MMM D, YYYY') : null;
    },
    hasPickupRequest() {
      return this.popup.item.is_pick_up && !this.popup.item.is_pick_up_complete;
    },
  },
  methods: {
    ...mapActions({
      getAdminList: 'mail/getAdminList',
      adminMailAction: 'mail/adminMailAction',
      adminMailGroupAction: 'mail/adminMailGroupAction',
      editMail: 'mail/editMail',
      getPickUpSettings: 'general/getPickUpSettings'
    }),
    SendRescheduleRequest(){
      if(this.rescheduleParams.reason == '') this.rescheduleParams.reason = null;
      this.rescheduleParams.reschedule_from_date && (this.rescheduleParams.reschedule_from_date = this.rescheduleParams.reschedule_from_date + 'T00:00:00.000Z');
      this.rescheduleParams.reschedule_to_date && (this.rescheduleParams.reschedule_to_date = this.rescheduleParams.reschedule_to_date + 'T23:59:59.000Z');
      const data = {
        id: this.popup.item.id,
        action: 'decline_pick_up', 
        params: {
          reason: this.rescheduleParams.reason,
          reschedule_from_date: this.rescheduleParams.reschedule_from_date,
          reschedule_to_date: this.rescheduleParams.reschedule_to_date,
        }
      }
      this.showSpinner = true;  
      this.adminMailAction(data)
      .then(res => {
        this.updateMailCallback(res.mail_item, data);
        this.popup.isOpen = false;
        this.rescheduleParams = {
          reschedule_from_date: null,
          reschedule_to_date: null,
          reason: ''
        }
        this.showSpinner = false;
      })
      .catch(this.handleActionError);
      
    },
    getMailList() {
      this.showSpinner = true;
      this.morePages = 0;

      let query = Object.assign({}, this.$route.query);

      if (!query.limit)
        query.limit = 24;

      if (query.order)
        query.order = JSON.parse(decodeURIComponent(query.order));

      if (this.account_id)
        query.account_id = this.account_id;

      this.getAdminList(query)
        .then(list => {
          this.pager.page = list.page;
          this.pager.pages = list.total_pages;
          this.pager.items = list.total_count;
          this.pager.onPage = parseInt(query.limit) || 24;

          this.list = list.mail_items;
          this.more = [];

          if (list.summary)
            this.summary = list.summary;

          this.showSpinner = false;
        });
    },
    getMoreMail() {
      this.showSpinner = true;
      this.morePages++;

      let query = Object.assign({}, this.$route.query);
      query.page = this.pager.page + this.morePages;
      query.limit = this.pager.onPage;

      if (query.order)
        query.order = JSON.parse(decodeURIComponent(query.order));

      if (this.account_id)
        query.account_id = this.account_id;

      this.getAdminList(query)
        .then(list => {
          this.more = [...this.more, ...list.mail_items];

          if (list.summary)
            this.summary = list.summary;

          this.showSpinner = false;
        });
    },
    sortTable(params) {
      this.$router.push({
        query: {
          ...this.$route.query,
          ...{
            order: encodeURIComponent(JSON.stringify(params))
          }
        }
      });
    },
    mailAction(data) {
      let item = this.mailList.find(item => item.id == data.id);
      if (data.action.includes('junk')) {
        item.actionOptions = MailParams.actions['junk'].options;
      }

      switch (data.action) {
        case 'edit':
          this.$router.push(`/admin/mail-edit?mail_number=${item.mail_number}`);
          break;
        case 'forward':
          this.$router.push(`/admin/mail-forwarding?mail_number=${item.mail_number}`);
          break;
        case 'scan':
        case 'picture':
        case 'pick_up_signature':
        case 'pick_up':
        case 'mark_as_pick_up':
          this.popup = {
            isOpen: true,
            type: data.action,
            item
          };
          break;
        // case 'pick_up':
        case 'shred':
        case 'check_deposit':
          this.processAction({
            id: item.id,
            action: data.action
          });
          break;
        case 'junk':
          if (item.is_junk)
            this.processAction({
              id: item.id,
              action: data.action,
              params: {
                enabled: !item.is_junk//true
              }
            });
          else
            this.popup = {
              isOpen: true,
              type: data.action,
              item
            };
          break;
        // case 'mark_as_pick_up':
        //   this.editMailParams(item.id, 'mark_as_pick_up_complete', true);
        //   break;
        case 'cancel_mark_as_pick_up':
          this.editMailParams(item.id, 'mark_as_pick_up_requested', false);
          break;
        case 'trash_now':
          this.trashNow(item.id);
          break;
        case 'cancel_junk':
          this.cancelJunk(item.id)
          break;
        default:
          break;
      }
    },

    handleActionError(e) {
      let err = e.response;

      if (err && err.data && err.data.errors) {
        this.backError = ParseErrorText(err.data.errors);
        this.popup.type = 'error';
        this.popup.isOpen = true;
      }

      this.showSpinner = false;
    },
    groupAction(data) {
      if (data.action === 'pick_up_signature' || data.action === 'junk') {
        if (data.action === 'junk') {
          data.actionOptions = MailParams.actions['junk'].options;
        }
        this.popup = {
          isOpen: true,
          type: `group_${data.action}`,
          item: data
        };
      } else {
        this.showSpinner = true;

        this.adminMailGroupAction(data)
          .then(res => {
            if (res.mail_items)
              res.mail_items.forEach(resItem => {
                this.updateMailCallback(resItem);
              });

            this.showSpinner = false;
          })
          .catch(this.handleActionError);
      }

    },
    mailSignature(data) {
      if (this.popup.type === "group_pick_up_signature") {
        this.showSpinner = true;

        this.adminMailGroupAction({
          ...this.popup.item,
          action: 'sign',
          signature_uri: data
        })
          .then(res => {
            if (res.mail_items)
              res.mail_items.forEach(resItem => {
                this.updateMailCallback(resItem);
              });

            this.popup.isOpen = false;
            this.showSpinner = false;
          })
          .catch(this.handleActionError);
      } else {
        this.processAction({
          id: this.popup.item.id,
          action: 'sign',
          params: {
            signature_uri: data
          }
        })
      }
    },
    uploadFile(file) {
      this.uploadedFile = file;
    },
    deleteFile() {
      this.uploadedFile = null;
    },
    submitUploadedFile() {
      let formData = new FormData();
      formData.append('file', this.uploadedFile);

      this.processAction({
        id: this.popup.item.id,
        action: this.popup.type,
        params: formData
      });
    },
    junk() {
      if (this.popup.type === "group_junk") {
        this.showSpinner = true;

        this.adminMailGroupAction({
          ...this.popup.item,
          action: "junk",
          enabled: true,
          trash_now: this.curTrash.value,
        })
          .then(res => {
            if (res.mail_items) {
              const data = {
                action: "junk",
                  params: {
                    enabled: true,
                    trash_now: this.curTrash.value,
                  }
              }
              res.mail_items.forEach(resItem => {
                this.updateMailCallback(resItem, data);
              });
            }

            this.popup.isOpen = false;
            this.showSpinner = false;
          })
          .catch(this.handleActionError);
      } else {
        this.processAction({
          id: this.popup.item.id,
          action: this.popup.type,
          params: {
            enabled: true,
            trash_now: this.curTrash.value,
          },
        });
      }




    },
    trashNow(id) {
      this.processAction({
        id,
        action: 'junk',
        params: {
          enabled: true,
          trash_now: true,
        },
      });
    },
    cancelJunk(id) {
      this.processAction({
        id,
        action: 'junk',
        params: {
          enabled: false,
          trash_now: false,
        },
      });
    },
    processAction(data) {
      this.showSpinner = true;

      this.adminMailAction(data)
        .then(res => {
          this.updateMailCallback(res.mail_item, data);
          this.popup.isOpen = false;
          this.showSpinner = false;
        })
        .catch(this.handleActionError);
    },
    editMailParams(mailId, param, value) {
      this.showSpinner = true;

      let formData = new FormData();

      formData.append(`mail_item[${param}]`, value);

      this.editMail({
        id: mailId,
        params: formData
      })
        .then(res => {
          this.updateMailCallback(res.mail_item);
          this.showSpinner = false;
        });
    },
    updateMailCallback(mail_item, data) {
      let shortcut = this.$route.query.shortcut;
      let isShortcutAction = shortcut && this.checkActionComplete(mail_item, shortcut);

      let index = this.list.findIndex(item => item.id == mail_item.id);

      if (index >= 0) {
        let arr = [...this.list];

        if (isShortcutAction || (data && data.action === 'junk' && data.params.trash_now))
          arr.splice(index, 1)
        else
          arr[index] = mail_item;

        this.list = arr;
        this.pager.items--;
        this.pager.onPage--;
      } else {
        index = this.more.findIndex(item => item.id == mail_item.id);
        let arr = [...this.more];

        if (isShortcutAction || (data && data.action === 'junk' && data.params.trash_now))
          arr.splice(index, 1)
        else
          arr[index] = mail_item;

        this.more = arr;
      }

      this.getAdminList()
        .then(list => {
          if (list.summary)
            this.summary = list.summary;
        });
    },
    checkActionComplete(mail_item, shortcut) {
      let data = ShortcutsData.find(item => item.value == shortcut);

      if (!data)
        return false;

      if (data.value == 'mark_as_junk')
        return !mail_item[data.result_item_field];

      return mail_item[data.result_item_field];
    },
    submitUploadedScans(scans) {
      let formData = new FormData();

      scans.forEach(scan => {
        formData.append('files[]', scan.file);
      })

      this.processAction({
        id: this.popup.item.id,
        action: this.popup.type,
        params: formData
      });
    },
    loadPickUpSettings() {
      if (this.provider.pick_up_scheduling_enabled) {
        this.getPickUpSettings()
          .then(res => {
            this.pickUpSettings = res.settings;
          });
      }
    },
    handleSchedulePickup(data) {
      this.selectedPickUpTime = data;
      this.showSpinner = true;

      let formData = new FormData();

      formData.append(`mail_item[pick_up_scheduled_at]`, this.selectedPickUpTime);


      const action = this.popup.type

      if (action == 'pick_up' || action == 'group_pick_up') {
        let params = {
          pick_up_scheduled_at: this.selectedPickUpTime,
        };

        this.processAction({
          id: this.popup.item.id,
          action: this.popup.type,
          params
        });

      } else if (action == 'mark_as_pick_up') {
        formData.append(`mail_item[mark_as_pick_up_complete]`, true);


        this.editMail({
          id: this.popup.item.id,
          params: formData
        })
          .then(res => {
            this.updateMailCallback(res.mail_item);
            this.showSpinner = false;
          });
      }
      this.pickUpProcess = 'pickup_schedule';
      this.popup.isOpen = false;
    }
  },
  watch: {
    'popup.isOpen'(val) {
      if (!val){
        this.uploadedFile = null;
        this.pickUpProcess = 'confirm_pickup';
        this.rescheduleParams = {
          reschedule_from_date: null,
          reschedule_to_date: null,
          reason: ''
        };
      }
      if (!this.pickUpSettings.length && (this.popup.type == 'pick_up' || this.popup.type == 'group_pick_up' || this.popup.type == 'mark_as_pick_up')) {
        this.loadPickUpSettings()
      }
    },
    '$route.query'(val) {
      this.getMailList(val);
    },
    summary(val) {
      this.$emit('summary', val);
    }
  }
}
</script>
